/**
 * Gets the number of decimals of the specified float number.
 *
 * @param number
 */
export function parseNumberOfDecimals(number) {
    if (!isFinite(number)) return 0;
    let e = 1, precision = 0;
    while (Math.round(number * e) / e !== number) {
        e *= 10;
        precision++;
    }

    return precision;
}

/**
 * Calculates the distance between the two lat lngs in kilometers.
 *
 * @param latLng1
 * @param latLng2
 * @returns {number}
 */
export function parseDistance(latLng1, latLng2) {
    const lat1 = latLng1.lat;
    const lng1 = latLng1.lng;
    const lat2 = latLng2.lat;
    const lng2 = latLng2.lng;

    const earthRadius = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lng2 - lng1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return earthRadius * c; // Distance in km
}

/**
 * Transforms the specified degrees in radius.
 *
 * @param deg
 * @returns {number}
 */
export function deg2rad(deg) {
    return deg * (Math.PI / 180)
}

export function parseUrlHost(url) {
    let match = url.match(/^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    return match[2];
}

/**
 * Extracts the urls of the specified text string.
 *
 * @param {string} text
 * @param includeWrapped Whether to match urls that are (probably) wrapped by tags.
 * @returns {array}
 */
export function extractUrls(text, includeWrapped = true) {
    if (!text || !text.length) {
        return [];
    }

    const matchPrefix = includeWrapped ? `(?:^|[^href"'])` : `(?:^|[^"'>https://])`; // Note that negative lookahead does not work on Safari
    const regex = new RegExp(`${matchPrefix}((https?:\\/\\/[^\\s!.]+.|https?:\\/\\/|www.[^\\s!.]+.|www.){1}(\\S+\\.\\w{2,})(\\/\\w+[\\w-\\/]+(\\.html)?)?([?#&]{1}[\\w=&#+-]+)?)`, 'gim');

    const links = [];
    let regexExtract;
    while ((regexExtract = regex.exec(text)) !== null) {
        links.push(regexExtract[1]); // The extracted url is the first matched group
    }

    // Filter duplicates
    return links && links.length ? links.filter((link, index, self) => self.indexOf(link) === index) : [];
}

export function parseBoolean(value) {
    return value && (value === 'true' || value === '1' || value === true || value === 1);
}

export function parseForInputType(type, value) {
    if (value === null || value === undefined) {
        return null;
    }
    if (Array.isArray(value)) {
        return value.map(itValue => parseForInputType(itValue)).join(', ');
    }

    if (type && type.is_boolean) {
        return parseBoolean(value);
    }

    if (type && type.value === 'date') {
        return this.$date(value).format('LL');
    }

    return value;
}